exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-tab{border:.5px solid #a9a5a5}.student{background-color:#d3d3d3}.teacher{background-color:#cbe8cb}.myefforts{overflow-x:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-eecf8234","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MyEffortsTeacher.vue
// module id = 667
// module chunks = 0